import React from "react";



const PageHeader = ({ title, children, style }) => {
  return (
    <>
      <div className="section-header">
        <div className="container">
          <div className="row container">
            <div className="col-md-12">
              <div className="text-center">
                <h2 className="page_title">
                  {children}
                </h2>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default PageHeader;
